module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/modules/_redefine.js
// module id = 351
// module chunks = 0